import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { ProfessionalAudience } from './components/ProfessionalAudience';
import { StatsBar } from './components/StatsBar';
import { TestimonialStrip } from './components/TestimonialStrip';
import { Problems } from './components/Problems';
import { Modules } from './components/Modules';
import { ModuleIncludes } from './components/ModuleIncludes';
import { Comparison } from './components/Comparison';
import { Bonuses } from './components/Bonuses';
import { PricingPack } from './components/PricingPack';
import { Guarantee } from './components/Guarantee';
import { Reviews } from './components/Reviews';
import { CostOfNotBuying } from './components/CostOfNotBuying';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
type MetaPixel = ((...args: unknown[]) => void) & {
  queue?: unknown[][];
  loaded?: boolean;
  version?: string;
};
declare global {
  interface Window {
    fbq?: MetaPixel;
    _fbq?: MetaPixel;
  }
}
const META_PIXEL_ID = '1748067973170675';
export function App() {
  useEffect(() => {
    if (window.fbq) {
      window.fbq('track', 'PageView');
      return;
    }
    const fbq: MetaPixel = (...args: unknown[]) => {
      fbq.queue?.push(args);
    };
    fbq.queue = [];
    fbq.loaded = true;
    fbq.version = '2.0';
    window.fbq = fbq;
    window._fbq = fbq;
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    fbq('init', META_PIXEL_ID);
    fbq('track', 'PageView');
  }, []);
  return <main className="w-full overflow-x-hidden bg-surface font-sans text-ink antialiased" data-id="element-0" data-mp="3dl4n5uey3vz1">
      <noscript data-id="element-1" data-mp="nw2ak1lu1ioz">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" data-mp="nuhgse7ce3s6" />
      </noscript>
      <Hero data-id="element-3" data-mp="35yp0k2nrm1g" />
      <ProfessionalAudience data-id="element-4" data-mp="35ovimiemwr0" />
      <StatsBar data-id="element-5" data-mp="34x4lozr5n72" />
      <TestimonialStrip data-id="element-6" data-mp="38ktuby5znfz" />
      <Problems data-id="element-7" data-mp="3ud1ff9ao9oam" />
      <Modules data-id="element-8" data-mp="3udkmfuysas9v" />
      <ModuleIncludes data-id="element-9" data-mp="3ubzsa6gdtbcj" />
      <Comparison data-id="element-10" data-mp="3ucje3y95kjvu" />
      <Bonuses data-id="element-11" data-mp="3uf5m1yzyh1el" />
      <PricingPack data-id="element-12" data-mp="d4e57s05daw6" />
      <Guarantee data-id="element-13" data-mp="d4xlz5e29t8m" />
      <Reviews data-id="element-14" data-mp="d3cr1enu48a8" />
      <CostOfNotBuying data-id="element-15" data-mp="d3wax0x1p6qw" />
      <FAQ data-id="element-16" data-mp="85l2mumef4as" />
      <FinalCTA data-id="element-17" data-mp="85uktw17c75x" />
      <Footer data-id="element-18" data-mp="85bd1859mz5m" />
    </main>;
}